import React, { useContext, useState } from "react";
import { Button, Row, Col } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { Context } from "../../Shared/Context/GlobalContext";
import routes from "../../Helpers/Routes.json";
import { Trans, useTranslation } from "react-i18next";
import { getQuestionComponents } from "../../Helpers/productHelper";
import { formatCurrency } from "../../Helpers/currency";
import { UpsellComponent } from "./__components/UpsellComponent";

export const AddToCartButton = ({
  originalProduct,
  product,
  bundledItems,
  afterBehaviour,
  validator,
  setError,
}) => {
  const [quantity, setQuantity] = useState(1);
  const [answers, setAnswers] = useState([]);
  const { addCartProducts, cartProducts } = useContext(Context);
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();

  let maxQty = product.stock_quantity > 0 ? product.stock_quantity : (product.type === "grouped" || product.type === "bundle" ? 999 : 1);

  const productQuestions = originalProduct.meta_data.find(
    (i) => i.key === "twc_product_questions"
  );

  const productQuestionsTitle = originalProduct.meta_data.find(
    (i) => i.key === "twc_product_questions_title"
  );

  let productQuestionObject = null;
  const questionsComponents = [];

  if (productQuestions) {
    productQuestionObject = JSON.parse(productQuestions.value);
    questionsComponents.push(
      getQuestionComponents(productQuestionObject, answers, setAnswers)
    );
  }

  const handleAddToCart = () => {
    const cartProduct = {
      product: {
        id: product.id,
        name: product.name,
        type: product.type,
        bundle: bundledItems,
        quantity: quantity,
        variation: product.variation,
        price: product.price,
        maxStock: maxQty,
      },
    };

    const valid = validator(product, cartProduct);

    if (productQuestionObject) {
      for (const productQuestion of productQuestionObject) {
        if (!answers[productQuestion.label]) {
          valid.success = false;
          if (valid.error) {
            valid.error += t("Falta seleccionar ") + productQuestion.label;
          } else {
            valid.error = t("Falta seleccionar ") + productQuestion.label;
          }
        }
      }
    }

    if (false === valid.success) {
      setError(valid.error);
      setTimeout(() => {
        ///    setError(null);
      }, 2 * 1000);
    }

    if (valid.success) {
      const data = cartProduct;

      if (answers) {
        for (const key of Object.keys(answers)) {
          const answer = {
            question: key,
            value: answers[key],
          };

          if (!data.product.answers) {
            data.product.answers = [answer];
          } else {
            data.product.answers.push(answer);
          }
        }
      }

      addCartProducts({ ...data });

      if (afterBehaviour) {
        afterBehaviour();
      } else {
        return navigate(
          routes.Homepage.category.replace(":category", params.category),
          {
            state: {
              product: t(product.name),
              variant: "light",
            },
          }
        );
      }
    }
  };

  let hasStock = product.stock_status === "instock";

  if (product.manage_stock !== false && product.stock_quantity > 0) {
    const cartProduct = cartProducts.find((i) => i.product.id === product.id);
    if (cartProduct) {
      if (cartProduct.product.quantity >= product.stock_quantity) {
        hasStock = false;
      }
    }
  }

  if (product.manage_stock !== false && product.stock_quantity <= 0) {
    hasStock = false;
  }

  return (
    <>
      {questionsComponents.length ? (
        <div className="mb-3">
          <h3 className="h6 fw-bold">
            {productQuestionsTitle ? productQuestionsTitle.value : t("Preguntas")}
          </h3>
          <Row>{questionsComponents}</Row>
        </div>
      ) : null}

      {product.upsells && product.upsells.length > 0 && (
        <div className="mb-3">
          {product.upsells.map((upsell) => (
            <UpsellComponent
              key={`upsell-${upsell.id}`}
              upsell={upsell}
              answers={answers}
              setAnswers={setAnswers}
            />
          ))}
        </div>
      )}

      <Row className="align-items-center g-2">
        <Col xs="auto">
          <div className="d-flex align-items-center gap-2">
            <Button
              variant="outline-secondary"
              size="sm"
              className="rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: "36px", height: "36px" }}
              disabled={product.stock_status !== "instock"}
              onClick={() => {
                if (quantity > 1) setQuantity(quantity - 1);
              }}
            >
              -
            </Button>
            <span className="fw-bold px-2" style={{ minWidth: "24px", textAlign: "center" }}>
              {quantity}
            </span>
            <Button
              variant="outline-secondary"
              size="sm"
              className="rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: "36px", height: "36px" }}
              disabled={!hasStock}
              onClick={() => {
                if (quantity < maxQty) setQuantity(quantity + 1);
              }}
            >
              +
            </Button>
          </div>
        </Col>
        <Col>
          <Button
            size="lg"
            variant="dark"
            className="w-100 rounded-pill fw-bold"
            disabled={!hasStock || JSON.stringify(product) === "{}"}
            onClick={() => handleAddToCart()}
          >
            {JSON.stringify(product) === "{}" ? (
              t("Selecciona una opción")
            ) : hasStock ? (
              <Trans
                i18nKey={"Añadir {{quantity}} al carrito"}
                values={{ quantity: quantity }}
              />
            ) : (
              t("Agotado")
            )}
          </Button>
        </Col>
      </Row>
    </>
  );
};
